import { onBeforeMount, ref } from 'vue'
import { RecordType } from '~/types/records/RecordType'
import { AlgoliaRecord } from '~/types/records/AlgoliaRecord'
import { getObjects } from '~/lib/algoliaHelper'


/**
 * Batch expand entities from Algolia by UUID
 *
 * @param recordType
 * @param uuids
 */
export const useExpandEntitiesFromAlgolia = (recordType: RecordType, uuids: string[]) =>  {
  const expandedEntities = ref<AlgoliaRecord[]>([])

  onBeforeMount(async () => {
    expandedEntities.value = await getObjects(recordType, uuids) as AlgoliaRecord[]
  })

  return expandedEntities
}
